import React from 'react';
import { SuggestionsList, SuggestionItem, LoadingContainer } from './addressSuggestion.styles';

const AddressSuggestionsList = ({ suggestions, onSelect, isLoading }) => {
  if (isLoading) {
    return (
      <SuggestionsList>
        <LoadingContainer>
          <span>Loading addresses...</span>
        </LoadingContainer>
      </SuggestionsList>
    );
  }

  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <SuggestionsList>
      {suggestions.map((address, index) => (
        <SuggestionItem
          key={index}
          onClick={() => onSelect(address?.propertyAddress)}
          isLast={index === suggestions.length - 1}
        >
          {address?.propertyAddress}
        </SuggestionItem>
      ))}
    </SuggestionsList>
  );
};

export default AddressSuggestionsList;
